import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var LinkedInTag = /*#__PURE__*/function () {
  function LinkedInTag() {
    _classCallCheck(this, LinkedInTag);

    this.partnerId = '';
    this.subDomain = 'dc';
    this.initialized = false;
  }

  _createClass(LinkedInTag, [{
    key: "verifyInit",
    value: function verifyInit() {
      if (!this.initialized) {
        this.warn('LinkedIn Insight Tag not initialized. Before using, call LinkedInTag.init with required params');
      }

      return this.initialized;
    }
  }, {
    key: "init",
    value: function init(partnerId) {
      var subDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dc';
      this.partnerId = partnerId;
      this.subDomain = subDomain;
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];

      window._linkedin_data_partner_ids.push(partnerId);

      var script = document.getElementsByTagName('script')[0];
      var tagScript = document.createElement('script');
      tagScript.type = 'text/javascript';
      tagScript.async = true;
      tagScript.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      script.parentNode.insertBefore(tagScript, script);
      this.initialized = true;
    }
  }, {
    key: "track",
    value: function track(conversionId, partnerId) {
      var subDomain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dc';
      if (!this.verifyInit()) return this.warn('You must call `init` before calling `track`.');
      partnerId = partnerId || this.partnerId || window._linkedin_data_partner_ids[0];
      subDomain = subDomain || this.subDomain;
      var url = "https://".concat(subDomain, ".ads.linkedin.com/collect/?pid=").concat(partnerId, "&fmt=gif");

      if (conversionId) {
        url = "".concat(url, "&conversionId=").concat(conversionId);
      }

      return url;
    }
  }]);

  return LinkedInTag;
}();
export default new LinkedInTag();